import { isDemoMode } from "../config/runtime";
import type { AdminRepository } from "./admin-repository";
import { apiRepository } from "./api-repository";
import { loadDemoRepository } from "./demo-repository-loader";
import { createDemoWorkspaceRepository } from "./demo-workspace-client";

export const adminRepository: AdminRepository = isDemoMode
  ? createDemoWorkspaceRepository(loadDemoRepository)
  : apiRepository;
